export default {
    listagem: {
        titulo_pagina: 'Resultados Editáveis',
        table: {
            empty: 'Nenhum Vns encontrado',
            nome: 'Vns',
            empresa: 'Empresa',
            resultado_editavel: 'Resultado Editável',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Editar Resultados Editáveis'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Nome do Vns'
            },
            report_editable: {
                label: 'Resultados Editáveis',
                description: 'Resultados que serão editados por vns'
            },
            exam: {
                label: 'Exame'
            },
            mnemonic: {
                label: 'Mnemônico'
            },
            action: {
                label: 'Ação'
            }
        },
        buttons: {
            adicionar_exame: 'Adicionar Exame',
            remover_exame: 'Remover Exame',
            botao_salvar: 'Salvar Resultados Editáveis'
        },
        update: {
            success: 'Resultados editáveis atualizados com Sucesso!',
            error: 'Erro ao atualizar os resultados editáveis!'
        }
    }
}
